import { render, staticRenderFns } from "./DisplayMillItem.vue?vue&type=template&id=0656af02"
import script from "./DisplayMillItem.vue?vue&type=script&lang=js"
export * from "./DisplayMillItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports